import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { ContaCaixaConfiguracao } from '../../models/conta-caixa-configuracao';
import { AcaoContaMenu } from '../../models/acao-conta-menu';
import { MessageService } from '@services/message.service';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';
import { ConfiguracaoCaixaComponent } from '../configuracao-caixa.component';
import { ConfiguracaoCaixaApiService } from '../../services/configuracao-caixa-api.service';
import { Permissao } from '@models/enums/permissao';

@Component({
  selector: 'app-configuracao-caixa-arquivadas',
  standalone: false,
  templateUrl: './configuracao-caixa-arquivadas.component.html',
  styleUrl: './configuracao-caixa-arquivadas.component.scss'
})
export class ConfiguracaoCaixaArquivadasComponent implements OnInit {

  contas: ContaCaixaConfiguracao[] = [];
  @ViewChild('configuracaoComponent') tabela!: ConfiguracaoCaixaComponent;

  acoesConta: AcaoContaMenu[] = [
    {
      label: 'Desarquivar conta',
      icon: 'pi-arrow-up-right-from-square',
      acao: (conta) => this.desarquivarContaClick(conta),
      permissao: Permissao.DESARQUIVAR_CONTA_CAIXA
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private messageService: MessageService,
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private dialog: MatDialog,
  ) { }


  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.contas = data['contas'];
    });
  }

  public reloadPage(): void {
    this.configuracaoCaixaApiService.getContasArquivadas().subscribe((contas: ContaCaixaConfiguracao[]) => {
      this.contas = contas;
    });
  }

  private desarquivarContaClick(conta: ContaCaixaConfiguracao): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      autoFocus: false
    });
    dialogRef.componentInstance.titulo = `Desarquivar conta`;
    dialogRef.componentInstance.mensagem = `A conta voltará a ser exibida nas listagens`;
    dialogRef.componentInstance.textoBtnConfirmacao = "Desarquivar";
    dialogRef.componentInstance.acaoConfirmacao = () => this.desarquivarConta(conta);
  }

  private desarquivarConta(conta: ContaCaixaConfiguracao): void {
    this.configuracaoCaixaApiService.desarquivarContaCaixa(conta.id).subscribe({
      next: () => {
        this.messageService.showToastSuccess("Conta desarquivada com sucesso.");
        this.reloadPage();
      }
    });
  }
}
